var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"alert alert-danger"},[_vm._v("\n    The number of revisions for this permit exceeds the allowed amount. You must\n    "),_c('router-link',{attrs:{"to":{name: 'PermitApplication', params: {projectType: _vm.projectType}}}},[_vm._v("\n      submit a new permit application.\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }